var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"app-navigation-loading-placeholder-entry"},[_c('div',{staticClass:"icon icon-loading"})])}]

export { render, staticRenderFns }